<div bsModal #messageUsModal="bs-modal" id="messageUs" class="modal fade" role="dialog"
  [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-lg-custom">
    <div class="modal-content">
      <h4 class="modal-title">Message Us</h4>
      <div class="modal-body pt-0">
        <div class="mb-3">Please use the form below to submit your message to Tower Hill.</div>

        <div class="section-title">
          Is this message related to an existing Claim?<span class="required-star">&nbsp;*</span>
        </div>
        <div class="options mb-3" btnRadioGroup required [(ngModel)]="isClaimsRelated">
          <button class="btn btn-primary" tabindex="0" role="button" [btnRadio]="true">
            Yes
          </button>
          <button class="btn btn-primary" tabindex="0" role="button" [btnRadio]="false">
            No
          </button>
        </div>

        <ng-container *ngIf="isClaimsRelated === true">
          <div class="section-title">Claim Number<span class="required-star">&nbsp;*</span></div>
          <div class="mb-3">
            <select class="form-control col-7" required name="claimNumber" [(ngModel)]="selectedClaimId">
              <option value="" selected>Select</option>
              <option *ngFor="let claim of claimDetails" [value]="claim.id">
                {{claim.text}}
              </option>
            </select>
          </div>
        </ng-container>

        <ng-container *ngIf="isClaimsRelated === false">
          <div class="section-title">Policy Number</div>
          <div class="mb-3">
            <select class="form-control col-4" name="policyNumber" [(ngModel)]="selectedPolicy">
              <option value="" selected>Select</option>
              <option *ngFor="let policyNum of policyList" [value]="policyNum">
                {{policyNum}}
              </option>
            </select>
          </div>

          <div *ngIf="selectedPolicy" class="font-weight-bold mb-3">
            If you need to submit a Claim for this policy, please proceed to <a class="link" (click)="routeToFnol()">File a Claim</a>.
          </div>
        </ng-container>

        <ng-container *ngIf="isClaimsRelated != null">
          <div class="section-title">Message<span class="required-star">&nbsp;*</span></div>
          <mat-form-field class="w-100">
            <textarea matInput required [maxlength]="maxMessageLength" [(ngModel)]="messageText"></textarea>
            <mat-hint align="end">{{ messageText?.length || 0 }} / {{maxMessageLength}}</mat-hint>
          </mat-form-field>
        </ng-container>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="cancelMessageUsModal()">
          Cancel
        </button>
        <button type="submit" class="btn btn-primary"
          [disabled]="isClaimsRelated == null || (isClaimsRelated && !selectedClaimId) || !messageText?.length"
          (click)="submitMessageUsModal()">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>

<p-dialog [modal]="true" [(visible)]="showCancelConfirm">
  <p-header>
    Warning
  </p-header>
  Are you sure you want to discard your message?
  <p-footer class="text-center alert-box">
    <button type="button" class="btn btn-primary footer-btn" (click)="showCancelConfirm=false">
      Cancel
    </button>
    <button type="button" class="btn btn-primary footer-btn" (click)="confirmCancel()">
      Confirm
    </button>
  </p-footer>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="showErrorModal">
  <p-header>
    Error
  </p-header>
  {{ errorMessage }}
  <p-footer class="text-center alert-box">
    <button type="button" class="btn btn-primary footer-btn" (click)="showErrorModal=false">
      OK
    </button>
  </p-footer>
</p-dialog>